interface PaymentInfoProps {
	paymentInfo:
		| {
				accountHolderName: string;
				accountHolderSurname: string;
				bankName: string;
		  }
		| undefined;
	handleEditPayment: () => void;
}

export const PaymentInfo = ({ paymentInfo, handleEditPayment }: PaymentInfoProps) => {
	if (!paymentInfo) return null;

	return (
		<div className="account-info">
			<div className="account-info-header">
				<h2 className="account-title">Hesap Bilgileri</h2>
				<button
					className="edit-button"
					onClick={handleEditPayment}
					aria-label="Edit payment information">
					<i className="icons-pen" />
				</button>
			</div>
			<div className="info-grid">
				<div className="info-item">
					<div className="label">Kart Sahibi</div>
					<div className="value">{`${paymentInfo.accountHolderName} ${paymentInfo.accountHolderSurname}`}</div>
				</div>
				<div className="info-item">
					<div className="label">Banka Adı</div>
					<div className="value">{paymentInfo.bankName}</div>
				</div>
			</div>
		</div>
	);
};
